// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSNtTFgpj5VkIwWWlhgWiwquWOvc60tOA",
  authDomain: "cfhwp-costume-contest.firebaseapp.com",
  projectId: "cfhwp-costume-contest",
  storageBucket: "cfhwp-costume-contest.firebasestorage.app",
  messagingSenderId: "738066110304",
  appId: "1:738066110304:web:5618ea225d4292a6ee7005",
  measurementId: "G-CGPD9ZXTJX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase services
export const db = getFirestore(app);       // Firestore database
export const storage = getStorage(app);    // Storage for images
export const auth = getAuth(app);          // Authentication (optional)
